import React from 'react';
import { motion } from 'framer-motion';
import { Phone, ArrowRight } from 'lucide-react';

const CTASection = ({ onOpenForm }) => {
  return (
    <section id="contatti" className="py-24 md:py-32 bg-slate-900 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(255,87,34,0.15),transparent_50%)]" />
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-8 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-[#FF5722] text-sm font-semibold uppercase tracking-wider">Inizia ora</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mt-4 mb-6">
            Pronto a risolvere i problemi del tuo tetto?
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto mb-10">
            Richiedi il sopralluogo gratuito e ricevi un preventivo dettagliato senza impegno.
            Il nostro tecnico ti ricontattera entro 24 ore.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              data-testid="cta-section-button"
              onClick={onOpenForm}
              className="inline-flex items-center gap-2 bg-[#FF5722] hover:bg-[#FF7043] text-white font-bold px-8 py-4 rounded-full transition-all duration-300 hover:shadow-[0_0_30px_rgba(255,87,34,0.4)] hover:-translate-y-0.5 text-base"
            >
              Richiedi Sopralluogo Gratuito
              <ArrowRight className="w-4 h-4" />
            </button>
            <a
              href="tel:800864621"
              className="inline-flex items-center gap-2 text-white border border-white/20 hover:border-white/40 hover:bg-white/5 px-8 py-4 rounded-full transition-all duration-300 font-medium"
            >
              <Phone className="w-4 h-4" />
              800 86 46 21
            </a>
          </div>

          <p className="text-sm text-slate-400 mt-6">Numero Verde Gratuito | Lun-Ven 8:00-19:00</p>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
